<template>
    <div class="c2b-container">
        <div class="c2b-router-name-container">
		<p class="c2b-router-name">CRM</p>
        </div>

	<div class="c2b-content mb-3">
		<Loading v-if="loading" />

		<NothingFound v-if="nothingToShow" />

		<div class="c2b-card" v-if="!loading">
			<div class="c2b-card-title">
				<p>Processos</p>
			</div>

			<div class="list-options-container">
				<div class="item-option" v-for="(act, index) in activityStarterList" :key="index" @click="selectStarterActivity(act)">
					<div class="item-option-active">
						<p class="item-option-title">{{act.name}}</p>
						<p class="item-option-description">{{act.description}}</p>
						<fa icon="chevron-right" class="item-option-icon" />
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="c2b-card" v-if="!loading">
		<div class="c2b-card-title">
			<p>{{chosenStarterActivity.name}}</p>
		</div>

		<div class="c2b-card-content">
			<div v-for="(input, key) in dynamicForm.form" :key="key">
				<div class="form-group" v-if="input.isText">
					<label>{{input.label}}</label>
					<input type="text" 
						class="form-control"
						v-model="input.value">
				</div>

				<div class="form-group" v-if="input.isMemo">
					<label>{{input.label}}</label>
					<textarea class="form-control"
						rows="3" 
						v-model="input.value"></textarea>
				</div>

				<div class="form-group" v-if="input.isDate">
					<label>{{input.label}}</label>
					<v-date-picker 
                                            :input-props="{'class': 'form-control'}" 
                                            popover-visibility="focus"
                                            v-model="input.value" />
				</div>

				<div class="form-group" v-if="input.isCheckbox">
					<label>
						<input type="checkbox" v-model="input.value">
						<span class="ml-2">{{input.label}}</span>
					</label>					
				</div>

				<div class="form-group" v-if="input.isDropdown">
					<label>{{input.label}}</label>

					<div v-if="!input.isDropdownLazy">
						<multiselect
							v-model="input.options.value"
							:options="input.options.responseList"
							:multiple="false"
							:show-labels="false"
							label="name"
							track-by="id"
							placeholder="" />					
					</div>
					<div v-if="input.isDropdownLazy">
						<multiselect
							v-model="input.options.value"
							:options="input.options.responseList"
							:loading="input.options.retrievingList"
							:multiple="false"
							:show-labels="false"
							:id="key"
							label="name"
							track-by="id"
							placeholder=""
							@search-change="getLazyInfo" />					
					</div>
				</div>
			</div>
		</div>

		<div class="c2b-card-actions">
			<button class="btn btn-primary"
				@click="createInstance(chosenStarterActivity, dynamicForm)"
				:disabled="creatingInstance">
				Gravar

				<Loading v-show="creatingInstance" />
			</button>
		</div>
	</div>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { ProcessStarterActivityModel } from '../models/ProcessStarterActivityModel'
import crmService from '../services/CrmService'
import { ActivitySchemaModel } from '../models/ActivitySchemaModel'
import { ActivityDynamicFormModel } from '../models/ActivityDynamicFormModel'
import Axios from 'axios'

export default {
	name: 'CrmView',
	data() {
		return {
			creatingInstance: false,
			activityStarterList: [],
			chosenStarterActivity: new ProcessStarterActivityModel(),
			dynamicForm: new ActivityDynamicFormModel(new ActivitySchemaModel()),
			loading: true,
		}
	},
	created() {
		const DEBOUNCE_API_CALL = 1500;
		this.getLazyInfo = _.debounce(this.getLazyInfo, DEBOUNCE_API_CALL)
	},
	async mounted() {
		this.loading = true

		try {
			this.activityStarterList = await crmService.getStarterActivityList()
			this.chosenStarterActivity = cloneDeep(this.activityStarterList[0])

			const activitySchema = await crmService.getActivitySchema(this.chosenStarterActivity.id)
			this.dynamicForm = new ActivityDynamicFormModel(activitySchema)
			this._retrieveNecessaryInfoForLists(this.dynamicForm)
		} catch(err) {
			this.$floatingAlert.error({
				message: err.message,
			})
		}

		this.loading = false
	},
	methods: {
		async createInstance(activity, dynamicForm) {
			this.creatingInstance = true

			try {
				const formInfo = dynamicForm.normalize()
				const validations = await crmService.validateActivityInstance(activity.id, formInfo)

				if (Array.isArray(validations) && !!validations.length) {
					const validationMessages = `
						${validations.map((v) => "<li class='ml-3'>"+v+"</li>").join('')}
					`;

					this.$floatingAlert.error({
						title: 'Alguns campos não estão preenchidos corretamente',
						message: validationMessages,
					})
				} else {
					await crmService.createInstance(activity.id, formInfo)
					this.$floatingAlert.success({
						message: 'Atendimento criado com sucesso',
					})
				}
			} catch (err) {
				this.$floatingAlert.error({
					message: err.message,
				})
			}

			this.creatingInstance = false
		},
		async selectStarterActivity(act) {
			try {
				const activitySchema = await crmService.getActivitySchema(act.id)
				this.chosenStarterActivity = cloneDeep(act);
				this.dynamicForm = new ActivityDynamicFormModel(activitySchema)		
				this._retrieveNecessaryInfoForLists(this.dynamicForm)
			} catch (err) {
				this.$floatingAlert.error({
					message: err.message,
				})
			}
		},
		async getLazyInfo(query, idKey) {
			for (const key in this.dynamicForm.form) {
				if (idKey === key) {
					if (!query || query.length < this.dynamicForm.form[idKey].options.queryParams[0].minLength) {
						this.dynamicForm.form[idKey].options.responseList = [];
						return;
					}

					this.dynamicForm.form[idKey].options.retrievingList = true;

					try {
						const {data} = await Axios.get(`${this.dynamicForm.form[idKey].options.url}?value=${query}`);
						this.dynamicForm.form[idKey].options.responseList = data;
					} catch (err) {
						this.$floatingAlert.error({
							message: err.message,
						})
					}

					this.dynamicForm.form[idKey].options.retrievingList = false;
				}
			}
		},
		async _retrieveNecessaryInfoForLists(dynForm) {
			try {
				Object.keys(dynForm.form).forEach(async (key) => {
					if (dynForm.form[key].isDropdown) {
						const {data} = await Axios.get(dynForm.form[key].options.url);
						dynForm.form[key].options.responseList = data;
					}
				})
			} catch (err) {
				this.$floatingAlert.error({
					message: err.message,
				})
			}
		},
	},
	computed: {
		nothingToShow() {
			return !this.loading && !this.activityStarterList.length
		},
	},
}
</script>